export const PAYZHE_BTP_AUTH_TOKEN_KEY = 'zeettu.payzheBtp.authToken';
export const PAYZHE_BTP_HTTP_BASE =
  (import.meta.env.VITE_PAYZHE_BTP_HTTP_BASE as string | undefined)?.trim() ||
  'http://127.0.0.1:38471';
export const PAYZHE_BTP_WS_BASE =
  (import.meta.env.VITE_PAYZHE_BTP_WS_BASE as string | undefined)?.trim() ||
  'ws://127.0.0.1:38472';
export const PAYZHE_BTP_PLAY_STORE_URL =
  (import.meta.env.VITE_PAYZHE_BTP_PLAY_STORE_URL as string | undefined)?.trim() ||
  'https://play.google.com/store/apps/details?id=com.payzhe.btp';
export const PAYZHE_BTP_DEEP_LINK = 'payzhebtp://open?source=bridge';
export const PAYZHE_BTP_REQUEST_TIMEOUT_MS = 6_000;
export const PAYZHE_BTP_PROBE_TIMEOUT_MS = 3_000;
export const PAYZHE_BTP_APK_DEFAULT_PATH = '/downloads/payzhe-btp.apk';
export const PAYZHE_BTP_APK_URL =
  (import.meta.env.VITE_PAYZHE_BTP_APK_URL as string | undefined)?.trim() || '';
